




































































import moment, { Moment } from 'moment'

import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter, State } from 'vuex-class'

import {
  InfiniteScroll,
  InvoiceTile,
  NetworkErrorEmptyState,
  PaceMaker,
  VsLoading
} from '@/components'

import { EmptyState, ListHeader, MobileLayout } from '@/layouts/components'

import { ActionButton, AsyncState, Invoice } from '@/models'

import { RootState } from '@/store/state'

import { isFood } from '@/utils'

@Component({
  components: {
    EmptyState,
    InfiniteScroll,
    InvoiceTile,
    ListHeader,
    MobileLayout,
    NetworkErrorEmptyState,
    PaceMaker,
    VsLoading
  }
})
export default class Invoices extends Vue {
  loadState = new AsyncState()

  now = moment()

  get buttons (): ActionButton[] {
    return [
      {
        icon: 'filter_list',
        color: 'dark',
        handler: () => { this.$router.push({ name: 'ChangeInvoiceFilters' }) }
      }
    ]
  }

  get invoiceGroups () {
    const today = this.now.clone().startOf('day')

    return this.invoiceGroupsByDay.map(([day, groupedInvoices]) => ({
      day,
      groupedInvoices,
      isToday: day.isSame(today)
    }))
  }

  get total (): number {
    return this.invoices.length
  }

  get invoiceTitle () {
    return isFood() ? 'Comandas' : 'Compras'
  }

  get emptyStateIcon () {
    return isFood() ? 'restaurant_menu' : 'list_alt'
  }

  get emptyStateTitle () {
    return isFood() ? 'comanda' : 'compra'
  }

  @State((state: RootState) => state.ordering.invoices.isDefaultFilters)
  readonly isDefaultFilters!: boolean

  @State((state: RootState) => state.ordering.invoices.didLoadAll)
  readonly didLoadAll!: boolean

  @Getter('ordering/filteredInvoices')
  readonly invoices!: Invoice[]

  @Getter('ordering/invoiceGroupsByDay')
  readonly invoiceGroupsByDay!: [Moment, Invoice[]][]

  @Action('ordering/loadInvoicePage')
  loadInvoicePage!: () => Promise<void>

  async created () {
    if (this.total === 0) {
      await this.reload()
    } else {
      this.loadState.touch()
    }
  }

  async reload () {
    try {
      await this.loadMore()
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  async loadMore () {
    await this.loadState.handle(
      this.loadInvoicePage()
    )

    return this.invoices.length > 0
  }
}
